export default "__VITE_ASSET__DxCC0MnO__"